import React from "react"

import CustomSelect from "../tailwind/CustomSelect"

const VariantOptions = props => {
  const { variants, options, formValues, setValue } = props

  return (
    <>
      {variants &&
        variants?.length > 1 &&
        options &&
        options.map(option => {
          const { id, name, values } = option

          return (
            <div key={id} className="my-4 mr-4 flex min-w-[200px] items-center">
              <CustomSelect
                labelClassName="mr-2 text-color-darkGrey"
                optionsClassName="w-full min-w-[150px] "
                label={name}
                options={values}
                name={name}
                value={formValues?.[name]}
                onChange={value => {
                  setValue(name, value)
                }}
              />
            </div>
          )
        })}
    </>
  )
}

export default VariantOptions
